import React from 'react';
import useLoading from '../../../hooks/loadingHook';
import LoadingSpinner from '../../../static/dashboard/loadingspinner.svg';
import BackArrow from '../../../static/dashboard/backarrow.svg';

export default function SettingsCancelSubscription({ history }) {
    
    const loadFunction = () => { // Replace code with function to cancel subscription
        return fetch("https://flash.siwalik.in/delay/500",
        {method: "GET"});
    }
    const loadingHandler = () => {
        history.push('/dashboard/settings/subscriptioncancelled');
    };



    const { loading, handleLoad } = useLoading(loadFunction, loadingHandler);

    return (
        <div className="SettingsCancelSubscription center-dashboard-content">
            <img
            className="back-arrow"
            onClick={(e) => history.goBack()} 
            src={BackArrow} 
            alt="Go Back"/>
            <div className="header header-short text-center">
                <h1>Are you sure you want to cancel?</h1>
                <p>{`You'll have access until ${new Intl.DateTimeFormat('en-US').format(Date.now())}. After that, 
                you'll lose access to Salewave.`} </p>
            </div>
            <button 
                className={`cancel-subscription-button ${loading ? 'loading-button' : ''}`}
                onClick={(e) => {
                    if (!loading) // Make sure can't click while loading.
                        handleLoad();
                }}>
                    {
                        loading 
                        ? 
                            <><img src={LoadingSpinner} alt="Loading"/>Cancelling</>
                        :   "Yes, Cancel"
                    }
            </button>
        </div>
    );
}